export default __webpack_public_path__ + "static/media/03.c99093f7.jpg";